import { render } from "./HeaderMenu.vue?vue&type=template&id=aac4f6c2&ts=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=aac4f6c2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__